/**
 * Zentrale HTML-Escaping-Helfer (R5-Dedup).
 *
 * EINE kanonische Implementierung für alle Frontend-Views/Components.
 * `escapeHtml` escaped alle 5 relevanten Zeichen (`& < > " '`); `&` MUSS zuerst
 * ersetzt werden. `escapeAttr` ist semantisch identisch (escapeHtml deckt Quotes
 * bereits ab) und existiert nur als sprechender Alias für Attribut-Kontexte.
 */

export function escapeHtml(s: string | null | undefined): string {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function escapeAttr(s: string | null | undefined): string {
  return escapeHtml(s);
}
